import axios from 'axios';

const defaultOptions = {
    headers: {},
    data: {},
};

const ApiCaller = (options = defaultOptions) => {
    const axiosInstance = axios.create({
        headers: {
            ...options?.headers,
        },
        data: {
            ...options?.data,
        },
        responseType: 'json',
    });

    axiosInstance.interceptors.request.use(
        async config => {
            if (options) {

                if (options.data)
                    config.data = options.data
            }
            return config;
        },
        error => {
            return Promise.reject(error);
        },
    );

    axiosInstance.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            const {response} = error;

            return Promise.reject(error);
        },
    );
    return axiosInstance;
};

export default ApiCaller;
